export function isBatchPriceReportRequested(status: string | undefined): boolean {
  return status === 'pricing' || status === 'done';
}
